export const XIcon = () => {
	return (
		<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<line x1="1.1934" y1="0.48629" x2="21.3534" y2="20.6463" stroke="white" />
			<line y1="-0.5" x2="28.5106" y2="-0.5" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 20.1602)" stroke="white" />
		</svg>
	)
}
